import { Directive, ElementRef, Input } from '@angular/core';

declare var $:any;

@Directive({
  selector: '[matchHeight]'
})
export class MatchHeightDirective {

  constructor(private el: ElementRef) { }

  @Input('matchHeight') groupName: string;

  ngAfterViewInit() {
    this.matchHeight(this.groupName);
  }

  private matchHeight(groupName: string) {
    this.el.nativeElement.setAttribute('data-mh', groupName);
    $.fn.matchHeight._applyDataApi();
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/match-height.directive.ts